import React from 'react';

import Podcast from '@/types/pages/api/podcasts/Podcast';

import { classNames } from '@core/utils/functions/class-names';
import PodcastCard from '@/components/pages/frontpage/components/Podcasts/PodcastCard';

type PodcastPageLayoutProps = {
    podcasts: Podcast[];
};

// eslint-disable-next-line import/prefer-default-export
const PodcastPageLayout = (props: PodcastPageLayoutProps) => {
    const { podcasts } = props;

    return (
        <>
            <div
                className={classNames(
                    'gap-10 p-10',
                    'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 flex-grow-0 flex-shrink-0 w-full'
                )}
            >
                {podcasts.map(podcast => (
                    <PodcastCard
                        key={podcast.id}
                        title={podcast.title}
                        slug={podcast.slug}
                        summary={podcast.summary}
                        imageFile={podcast.imageFile}
                        itunesCategories={podcast.itunesCategories}
                        feedUrl={podcast.feedUrl}
                        spotifyIdentifier={podcast.spotifyIdentifier}
                        stitcherIdentifier={podcast.stitcherIdentifier}
                        itunesIdentifier={podcast.itunesIdentifier}
                    />
                ))}
            </div>
        </>
    );
};

export default PodcastPageLayout;
